import React from "react";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";

function Terms() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();

  const goToPage = () => {
    navigate("/AddLocations");
  };

  const handleSearchChange = (event) => {
    // Update searchText when typing in TextField
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Account</Link>
                <Link underline="none">Terms & Conditions</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box
        sx={{
          ...styles.box_container_add,
          height: "80vh",
          pb: 2,
          overflowY: "auto",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                Terms and Conditions
              </Typography>
            </Box>
          </Grid>
          <Box sx={styles.box_containerbody_terms}>
            <Grid item xs={12} p={1}>
              <Typography variant="body1" align="left">
                These Terms and Conditions constitute a legally binding
                agreement made between you, whether personally or on behalf of
                an entity (hereinafter referred to as “you”) and SECVISION
                (PRIVATE) LIMITED hereinafter referred to as “we,” “us” or
                “our”), concerning your access to and use of our ESKAIY-ERP
                System, hosted at erp.eskaiy.com website as well as any other
                media form, media channel, mobile website or mobile application
                related, linked, or otherwise connected thereto (collectively,
                the “Site”).
              </Typography>
            </Grid>

            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                You agree that by accessing the Site, you have read, understood,
                and agree to be bound by all of these Terms and Conditions. If
                you do not agree with all of these Terms and Conditions, then
                you are expressly prohibited from using the Site and you must
                discontinue use immediately.
              </Typography>
            </Grid>
            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                Supplemental terms and conditions or documents that may be
                posted on the Site from time to time are hereby expressly
                incorporated herein by reference. We reserve the right, in our
                sole discretion, to make changes or modifications to these Terms
                and Conditions at any time and for any reason.
              </Typography>
            </Grid>
            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                We will alert you about any changes by updating the “Last
                updated” date of these Terms and Conditions, and you waive any
                right to receive specific notice of each such change.
              </Typography>
            </Grid>
            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                It is your responsibility to periodically review these Terms and
                Conditions to stay informed of updates. You will be subject to,
                and will be deemed to have been made aware of and to have
                accepted, the changes in any revised Terms and Conditions by
                your continued use of the Site after the date such revised Terms
                and Conditions are posted.
              </Typography>
            </Grid>
            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                The information provided on the Site is not intended for
                distribution to or use by any person or entity in any
                jurisdiction or country where such distribution or use would be
                contrary to law or regulation or which would subject us to any
                registration requirement within such jurisdiction or country.
              </Typography>
            </Grid>

            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                Accordingly, those persons who choose to access the Site from
                other locations do so on their own initiative and are solely
                responsible for compliance with local laws, if and to the extent
                local laws are applicable.
              </Typography>
            </Grid>
          </Box>

          {/* <Box sx={styles.box_containerbody}> */}
          <Grid item xs={12} mt={2}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                Intellectual Property Rights
              </Typography>
            </Box>
          </Grid>

          <Box sx={styles.box_containerbody_terms}>
            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                Unless otherwise indicated, the Site is our proprietary property
                and all source code, databases, functionality, software, website
                designs, audio, video, text, photographs, and graphics on the
                Site (collectively, the “Content”) and the trademarks, service
                marks, and logos contained therein (the “Marks”) are owned or
                controlled by us or licensed to us,
              </Typography>
            </Grid>
            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                The Content and the Marks are provided on the Site “AS IS” for
                your information and personal use only. Except as expressly
                provided in these Terms and Conditions, no part of the Site and
                no Content or Marks may be copied, reproduced, aggregated,
                republished, uploaded, posted, publicly displayed, encoded,
                translated, transmitted, distributed, sold, licensed, or
                otherwise exploited for any commercial purpose whatsoever,
                without our express prior written permission.
              </Typography>
            </Grid>

            <Grid item p={1} xs={12}>
              <Typography variant="body1" align="left">
                Provided that you are eligible to use the Site, you are granted
                a limited license to access and use the Site and to download or
                print a copy of any portion of the Content to which you have
                properly gained access solely for your personal, non-commercial
                use. We reserve all rights not expressly granted to you in and
                to the Site, the Content and the Marks.
              </Typography>
            </Grid>
          </Box>
          {/* </Box> */}
        </Grid>
      </Box>
    </div>
  );
}

export default Terms;
